import type BaseObserver from './baseObserver';
import TableModelObserver from './tableModelObserver';
import CellModelObserver from './cellModelObserver';
import ShapeModelObserver from './shapeModelObserver';
import PictureModelObserver from './pictureModelObserver';
import GroupModelObserver from './groupModelObserver';
import ChartModelObserver from './chartObserver';
import ConnectorModelObserver from './connectorModelObserver';
import SmartArtModelObserver from './smartArtModelObserver';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import type { IMediaManager } from '@src/slide/application/service/media-manager/media-manager.interface';
import type { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import type EditingStateManager from '@src/slide/application/service/editing-state-manager';

// 保存model对象的observer信息
const modelObserverMap = new WeakMap();
export default class ObserverFactory {
    private static mediaManager?: IMediaManager;
    private static editingStateManager?: EditingStateManager;

    public static createObserver(model: Record<string, any>) {
        let observer: any = modelObserverMap.get(model);
        if (!observer) {
            const ObserverClass = ObserverFactory.getObserverClass(model);
            const observerClassOptions = ObserverFactory.getObserverClassOptions(model as IBaseModel);
            if (ObserverClass) {
                observer = new ObserverClass(model, observerClassOptions);
                modelObserverMap.set(model, observer);
            }
        }
        return observer;
    }

    public static setMediaManagerDelegate(mediaManager: IMediaManager): void {
        if (ObserverFactory.mediaManager) return;
        ObserverFactory.mediaManager = mediaManager;
    }

    public static setEditingStateManagerDelegate(editingStateManager: EditingStateManager): void {
        if (ObserverFactory.editingStateManager) return;
        ObserverFactory.editingStateManager = editingStateManager;
    }

    private static getObserverClass(uiData: any): typeof BaseObserver {
        const classMap = {
            [UIModelType.CONNECTOR]: ConnectorModelObserver,
            [UIModelType.GROUP]: GroupModelObserver,
            [UIModelType.IMAGE]: PictureModelObserver,
            [UIModelType.TABLE]: TableModelObserver,
            [UIModelType.SHAPE]: uiData.inTable ? CellModelObserver : ShapeModelObserver,
            [UIModelType.CHART]: ChartModelObserver,
            [UIModelType.SMART_ART]: SmartArtModelObserver,
        };
        const convert: any = classMap[uiData.type] || null;
        return convert;
    }

    private static getObserverClassOptions(uiData: IBaseModel): any {
        switch (uiData.type) {
            case UIModelType.SHAPE:
                return {
                    mediaManager: ObserverFactory.mediaManager,
                };
            case UIModelType.IMAGE:
                return {
                    editingStateManager: ObserverFactory.editingStateManager,
                    mediaManager: ObserverFactory.mediaManager,
                };
            default:
                return {};
        }
    }
}
